import { AxiosRequestConfig } from "axios";
import { IHttpClient } from "../../../lib/http";

export interface SendReservationMessagePayload {
  propertyTicker: string;
  reservationId: string;
  locale: string;
  phone: string;
}

export async function sendReservationMessage(
  httpClient: IHttpClient,
  payload: SendReservationMessagePayload,
  config?: AxiosRequestConfig
): Promise<void> {
  const { propertyTicker, reservationId, ...body } = payload;
  await httpClient.post(
    `/properties/${propertyTicker}/reservations/${reservationId}/welcome/test-send`,
    body,
    config
  );
}
